<div class="maindiv">
    <simple-datagrid entityName="Mktpamazon" [parentRow]="parentRow" [condition]="condition" [componentedit]="criacaoProduto"></simple-datagrid>
</div>
